import React, { useState } from 'react';
import Spacing from '../Spacing';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
import { pageTitle } from '../../helpers/PageTitle';
import { Icon } from '@iconify/react';
import EmailSender from '../../api/EmailSender';
import './ContactPage.css';

export default function ContactPage() {
  pageTitle('Contact');

  const { isSubmitting, succeeded, error, sendEmail } = EmailSender();
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Basic validation
    if (!formData.fullName.trim() || !formData.email.trim() || !formData.phone.trim() || !formData.message.trim()) {
      alert('Please fill in all fields');
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      alert('Please enter a valid email address');
      return;
    }

    // Phone validation
    if (formData.phone.length < 10) {
      alert('Please enter a valid phone number');
      return;
    }
    
    console.log('Submitting form with data:', formData);
    
    const success = await sendEmail(
      formData,
      "New Contact Form Submission - Ignite Sports Pavilion"
    );

    if (success) {
      setFormData({
        fullName: '',
        email: '',
        phone: '',
        message: '',
      });
    }
  };

  return (
    <>
      <style>
        {`
      cs_dark .cs_form_field {
            border-radius: 10px;
          }
   .cs_dark .cs_form_field {
    color: #121212;
    // height: 42px;
}
    .cs_form_field {
    background-color: #fff;
    line-height: 1.6em;
    padding: 17px 10px;
}
        `
        }
        
      </style>
      {/* <Spacing lg="70" md="70" /> */}
      <Spacing lg="140" md="80" />
      {/* <SectionHeadingStyle3
        title=""
        subTitle="Contact"
        shape="shape_6"
      /> */}
      <Spacing lg="75" md="60" />
      <section>
        <div className="container">
          <div className="row align-items-center cs_gap_y_45">
            <div className="col-lg-6">
              {/* <p className='cs_fs_21  cs_primary_color cs_section_subtitle' style={{lineHeight: '10px !important'}}>-Conatct</p> */}
              <SectionHeadingStyle3
        title=""
        subTitle="Contact"
        shape="shape_6"
      /> 
              <h2 className="cs_fs_50">
              Get in touch for more  <br />
              information and support
              </h2>
              <div className="cs_height_55 cs_height_lg_30" />
              <ul className="cs_mp0 cs_contact_info">
                <li>
                  <h3 className="cs_fs_29 cs_semibold">Email:</h3>
                  <p className="mb-0"> info@ignitesportspavilion.com</p>
                </li>
                <li>
                  <h3 className="cs_fs_29 cs_semibold">Phone:</h3>
                  <p className="mb-0">+92 319 3446483</p>
                </li>
                <li>
                  <h3 className="cs_fs_29 cs_semibold">Address:</h3>
                  <p className="mb-0">ST 13, Block 3 Clifton, Karachi</p>
                </li>
              </ul>
            </div>
            <div className="col-lg-6">
              <div className="cs_contact_form_wrap">
                <div className="cs_gray_bg_3 cs_contact_form_bg" />
                <form className="cs_contact_form" onSubmit={handleSubmit}>
                  <label className="cs_fs_21 cs_semibold cs_primary_color">
                    Name
                  </label>
                  <input
                    placeholder="Type your name"
                    type="text"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleChange}
                    className="cs_form_field"
                    required
                  />
                  <div className="cs_height_38 cs_height_lg_25" />
                  <label className="cs_fs_21 cs_semibold cs_primary_color">
                    Email
                  </label>
                  <input
                    placeholder="Type your email address"
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="cs_form_field"
                    required
                  />
                  <div className="cs_height_38 cs_height_lg_25" />
                  <label className="cs_fs_21 cs_semibold cs_primary_color">
                    Phone
                  </label>
                  <input
                    placeholder="Type your phone number"
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value.length <= 13) {
                        handleChange(e);
                      }
                    }}
                    className="cs_form_field"
                    pattern="[0-9]*"
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    maxLength={13}
                    required
                  />
                  <div className="cs_height_38 cs_height_lg_25" />
                  <label className="cs_fs_21 cs_semibold cs_primary_color">
                    Message
                  </label>
                  <textarea
                    cols={30}
                    rows={5}
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="cs_form_field"
                    required
                  
                  />
                  <div className="cs_height_38 cs_height_lg_25" />
                  <button className="cs_btn cs_style_1" type="submit" disabled={isSubmitting}>
                    {isSubmitting ? "Sending..." : "Submit"}
                    <span>
                      <i>
                        <Icon icon="fa6-solid:arrow-right" />
                      </i>
                      <i>
                        <Icon icon="fa6-solid:arrow-right" />
                      </i>
                    </span>
                  </button>
                  {succeeded && (
                    <div className="alert alert-success mt-3">
                      Thank you for your message. We'll get back to you shortly!
                    </div>
                  )}
                  {error && (
                    <div className="alert alert-danger mt-3">
                      {error}
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="cs_height_0 cs_height_lg_80" /> */}
      </section>
      <div className="cs_map">
        <iframe
          id="map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14485.93130876994!2d67.00519631017889!3d24.813156745197773!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33d002dd75313%3A0xaef77f5726888000!2sIGNITE%20Sports%20Pavilion!5e0!3m2!1sen!2s!4v1750663471415!5m2!1sen!2s"
          allowFullScreen
          title="Google Map"
        />
      </div>
      <div className="cs_height_120 cs_height_lg_80" />

    </>
  );
}
